module.exports = __webpack_public_path__ + "img/tip.08c1fee7.png";